import {FilterButtonClickedEvent, FiltersSubmittedEvent} from "./events";
import {EventBus} from "../../../../common/ts/events/EventBus";
import {WhitelabelEvent} from "../../../../common/ts/events/Events";
import tracking from "../../../../common/ts/core/tracking";
import {paidParamsFrom} from "../paidParamsFrom";
import {retentionParamsFrom} from "../retentionParamsFrom";
import dom from "../../../../common/ts/core/dom";
import {MODAL_FILTERS_CONTAINER_SELECTORS, MODAL_FILTERS_SELECTOR} from "./constants";
import location from "../../../../common/ts/core/location";
import {navigateToUserSearchWith} from "../../navigateToUserSearchWith";

let eventBus: EventBus;

export function filterSubmittedEventHandler(event: WhitelabelEvent) {
    const { payload: { formData, searchParams } } =(event as FiltersSubmittedEvent);
    eventBus.emit(new tracking.TrackAnalyticsEvent({
        name: 'serp-filters'
    }));

    const cleanFormData = cleanEmptyValues(formData)
    const retentionParamsObject = Object.fromEntries(retentionParamsFrom(searchParams));
    const paidSearchParamsObject = Object.fromEntries(paidParamsFrom(searchParams));

    const newSearchParams = new URLSearchParams({
        ...cleanFormData,
        ...retentionParamsObject,
        ...paidSearchParamsObject}
    );
    const host = location.getOrigin();
    eventBus.emit(navigateToUserSearchWith(host, newSearchParams));
}

export function filterButtonClickedEventHandler(event: WhitelabelEvent) {
    const { payload: { filterName } } = (event as FilterButtonClickedEvent);

    if(filterName == null) {
        eventBus.emit(new dom.ShowEvent({selector: MODAL_FILTERS_SELECTOR}));
        return;
    }

    eventBus.emitMany([
        new dom.HideEvent({selector: MODAL_FILTERS_SELECTOR}),
        new dom.ShowEvent({selector: MODAL_FILTERS_CONTAINER_SELECTORS[filterName]})
    ])
}

function init(ev: any = EventBus.getInstance()) {
    eventBus = ev;
    eventBus.subscribe(FiltersSubmittedEvent.MODAL_TYPE, filterSubmittedEventHandler)
    eventBus.subscribe(FiltersSubmittedEvent.FORM_TYPE, filterSubmittedEventHandler)
    eventBus.subscribeWithId(
        FilterButtonClickedEvent.TYPE,
        {
            id: `${FilterButtonClickedEvent.TYPE}-handler`,
            callback: filterButtonClickedEventHandler
        }
    )
}

export default {
    init
};

function cleanEmptyValues(object: { [p: string]: string }) {
    return Object.fromEntries(Object.entries(object).filter(([_, value]) => {
        return value != "" && value != null;
    }));
}